import apiClient from './client';

// ------------------------------------------------------------------
// 五维配置 —— MCP 工具（McpServer 一等实体）
// 占位模块：复用主平台端点，后续工作台任务填充 UI。
//   GET    /api/v1/agents/{agent_id}/mcp-servers
//   POST   /api/v1/agents/{agent_id}/mcp-servers
//   PUT    /api/v1/agents/{agent_id}/mcp-servers/{server_id}
//   DELETE /api/v1/agents/{agent_id}/mcp-servers/{server_id}
// ------------------------------------------------------------------

export interface McpServer {
  id: string;
  name: string;
  command?: string;
  args?: string[];
  env?: Record<string, string>;
  enabled?: boolean;
  created_at?: string;
}

export interface CreateMcpServerInput {
  name: string;
  command?: string;
  args?: string[];
  env?: Record<string, string>;
  enabled?: boolean;
}

export async function listMcpServers(agentId: string): Promise<McpServer[]> {
  const res = await apiClient.get<McpServer[]>(`/agents/${agentId}/mcp-servers`);
  return res.data;
}

export async function createMcpServer(agentId: string, input: CreateMcpServerInput): Promise<McpServer> {
  const res = await apiClient.post<McpServer>(`/agents/${agentId}/mcp-servers`, input);
  return res.data;
}

export async function updateMcpServer(
  agentId: string,
  serverId: string,
  input: Partial<CreateMcpServerInput>
): Promise<McpServer> {
  const res = await apiClient.put<McpServer>(`/agents/${agentId}/mcp-servers/${serverId}`, input);
  return res.data;
}

export async function deleteMcpServer(agentId: string, serverId: string): Promise<void> {
  await apiClient.delete(`/agents/${agentId}/mcp-servers/${serverId}`);
}
